export const zu: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Ideshibhodi (Dashboard)',
  'nav.focus': 'Umgomo Wosuku & Indlela Yokusebenza',
  'nav.ai_assistant': 'Injini Yokusebenza Ezenzekelayo',
  'nav.calendar': 'Ikhalenda ye-Google',
  'nav.book': 'Ikhasi Lokubhukha Komphakathi',
  'nav.bookings': 'Ukubhukha & Nemali Engenayo',
  'nav.invoices': 'Ama-invoyisi (Invoices)',
  'nav.expenses': 'Izindleko Zebhizinisi',
  'nav.settings': 'Indlunkulu Yebhizinisi & Nentela',
  'nav.billing': 'Ukubhalisa Nezinhlelo',
  'nav.j_lens': 'Indawo Ephephile ye-J-Lens',
  'nav.concept': 'Umqondo & Nendlela Yokucabanga',
  'nav.what_is': 'Yini i-AzuraOS?',
  'nav.export': 'Khipha & Londoloza Idatha',
  'nav.menu': 'Imenyu',
  'nav.welcome': 'Siyakwamukela & Isizinda se-BYOK',
  'nav.app_stack_modules': 'Amamojula Ohlelo',
  'nav.core_engines': 'Iz咫injini Eziyisi-8 Eziyinhloko',
  'nav.manifesto': 'Uhlelo & Nesimemezelo Sabasunguli',
  'nav.workspace_actions': 'Izenzo Zendawo Yokusebenza',
  'nav.export_records': 'Khipha Amarekhodi',
  'nav.load_demo': 'Layisha Idatha Yesivivinyo',
  'nav.partnerships': 'Ubambiswano & Nokuxhaswa',
  'nav.request_partnership': 'Cela Ukufinyelela Kobambiswano',
  'nav.partner_subtext': 'Ukuhlanganiswa kwamabhange, amaqembu nezibonelelo',
  'nav.interface_language': 'Ulimi Lwesistimu',
  'nav.legal_trust': 'Ezomthetho & Nokwethembeka',
  'nav.security': 'Ukuphepha',
  'nav.faqs': 'Imibuzo Ebuzwa Njalo',
  'nav.terms': 'Imigomo Nemibandela',
  'nav.privacy': 'Ubumfihlo',
  'nav.refund': 'Inqubomgomo Yokubuyiselwa Imali',
  'nav.contact': 'Xhumana Nathi',
  'nav.report_bug': 'Bika Inkinga',
  'nav.invite_founder': '+ Mema Umsunguli',
  'nav.privacy_active': 'Imodi Yobumfihlo: IYASEBENZA',
  'nav.privacy_off': 'Imodi Yobumfihlo: IVALIWE',
  'nav.masked': 'Kufihliwe',
  'nav.visible': 'Kuyabonakala',
  'nav.live_margin': 'INZUZO YOKUSEBENZA EBUKHOMA',
  'nav.target_safe_zone': 'Umgomo Wendawo Ephephile:',
  'nav.close_menu': 'Vala Imenyu',
  'nav.founder_access': 'Ngena / Ukufinyelela Komsunguli',
  'nav.private_vault': 'Indawo Ephephile Ixhunyiwe',
  'nav.master_access': 'Ukufinyelela Okuyinhloko Komsunguli',
  'nav.lifetime': 'Impilo Yonke',
  'nav.pro_active': 'I-Sovereign Pro Iyasebenza',
  'nav.trial_days': 'Isivivinyo Sezinsuku ezingu-7: Kusele izinsuku ezingu-{days}',
  'nav.trial_expired': 'Isikhathi Sesivivinyo Siphelile',
  'nav.manage': 'Phatha →',
  'nav.upgrade': 'Khuphula Izinga →',
  'nav.unlock_pro': 'Vula i-Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Sawubona ekuseni',
  'dash.greeting_afternoon': 'Sawubona emini',
  'dash.greeting_evening': 'Sawubona kusihlwa',
  'dash.value_prop': 'Ukulawula imithombo eminingi endaweni eyodwa: Faka umthombo o-1 wemali nendleko e-1 ukuze ubone inzuzo yakho yangempela ibukhoma.',
  'dash.manage_streams': 'Phatha Imithombo Yemali',
  'dash.close_streams': 'Vala Imithombo',
  'dash.income': 'Imali Engenayo Yonke',
  'dash.collected': 'Eyamukelwe',
  'dash.unpaid': 'Engakhokhiwe',
  'dash.expenses': 'Izindleko Zebhizinisi',
  'dash.across_records': 'Kuyo yonke idatha',
  'dash.net_profit': 'Inzuzo Yangempela (Net Profit)',
  'dash.daily_focus_title': 'Umgomo Wansuku Zonke & Nohlelo Lwemali',
  'dash.daily_focus_sub': 'Imisebenzi ebalulekile eyandisa inzuzo nokukhula kwebhizinisi',
  'dash.open_focus': 'Vula Umhlahlandlela Wemisebenzi',
  'dash.stream_profitability': 'Inzuzo Yomthombo Ngamunye',
  'dash.stream_sub': 'Isevisi e-1 noma imithombo eminingi • Ukulandelela inzuzo bukhoma',
  'dash.quick_actions': 'Izenzo Ezisheshayo',
  'dash.add_booking': 'Faka Ikhasimende / Ukubhukha',
  'dash.add_booking_desc': 'Bhalisa umthombo omusha wemali yekhasimende',
  'dash.add_expense': 'Faka Izindleko',
  'dash.add_expense_desc': 'Bhalisa izindleko zokusebenza kwebhizinisi',
  'dash.add_insight': 'Faka Isifundo / Iseluleko',
  'dash.add_insight_desc': 'Gcina umthetho omusha we-J-Lens',
  'dash.quick_add_title': 'Ukufaka Okusheshayo',
  'dash.quick_revenue': '+ IMALI ENGENA SHESHA (UKUBHUKHA)',
  'dash.quick_expense': '+ INDLEKO ESHESHAYO (ILEJA)',
  'dash.recent_activity': 'Imisebenzi Yakamuva',
  'dash.no_activity': 'Ayikho imisebenzi erekhodiwe okwamanje. Sebenzisa izenzo ezisheshayo ngenhla ukuze uqale.',
  'dash.spotlight_insight': 'Iseluleko Esivelele se-J-Lens',
  'dash.access_vault': 'Vula Indawo Ephephile →',
  'dash.sandbox_active': 'Imodi Yesivivinyo Iyasebenza',
  'dash.load_demo_data': 'Layisha Idatha Yesivivinyo',
  'dash.clear_sandbox': 'Sula Idatha Yesivivinyo',
  'dash.clear_confirm': 'Ufuna ukusula idatha?',
  'dash.yes_clear': 'Yebo, sula',
  'dash.cancel': 'Khansela',

  // Bookings View
  'bookings.title': '📅 Ukubhukha & Nemithombo Yemali',
  'bookings.subtitle': 'Imigudu yenzuzo yamakhasimende ehlukene',
  'bookings.public_page': 'Ikhasi Lokubhukha Komphakathi',
  'bookings.import_csv': 'Faka Ifayela le-CSV',
  'bookings.add_button': 'Faka Ukubhukha',
  'bookings.client_link_title': 'Isixhumanisi Sekhasimende Sokuzibhukhela',
  'bookings.client_link_desc': 'Yabelana ngezixhumanisi zokubhukha ezivumelaniswe neKhalenda ye-Google.',
  'bookings.link_active': 'Kuyasebenza',
  'bookings.generate_custom_link': '⚡ Yakha Isixhumanisi Sentengo Eyisipesheli',
  'bookings.hide_custom_link': 'Fihla Isixhumanisi Sentengo',
  'bookings.copy_standard_link': 'Kopisha Isixhumanisi Esijwayelekile',
  'bookings.copied_link': 'Isixhumanisi Sikopishiwe!',
  'bookings.preview': 'Buka Kuqala',
  'bookings.search_placeholder': 'Sesha ngegama lekhasimende noma isevisi...',
  'bookings.filter_all': 'Yonke Imithombo',
  'bookings.table_client': 'Igama Lekhasimende',
  'bookings.table_stream': 'Isevisi / Umthombo',
  'bookings.table_date': 'Usuku',
  'bookings.table_amount': 'Inani',
  'bookings.table_status': 'Isimo',
  'bookings.table_actions': 'Izenzo',
  'bookings.mark_paid': 'Maka Njengekhokhiwe',
  'bookings.mark_unpaid': 'Maka Njengengakhokhiwe',
  'bookings.delete': 'Susa',
  'bookings.no_records': 'Akukho ukubhukha kwamakhasimende okutholakele. Sebenzisa "Faka Ukubhukha" ngenhla.',

  // Invoices View
  'invoices.title': '📄 Ama-invoyisi & Nemali Elindelekile',
  'invoices.subtitle': 'Ukukhiqizwa kwama-invoyisi anobuchwepheshe nokulawulwa kwezinkokhelo',
  'invoices.create_invoice': 'Yakha I-invoyisi Entsha',
  'invoices.tab_all': 'Wonke Ama-invoyisi',
  'invoices.tab_paid': 'Ama-invoyisi Akhokhiwe',
  'invoices.tab_outstanding': 'Asalindelekile',
  'invoices.tab_overdue': 'Adlule Isikhathi',
  'invoices.table_number': 'I-invoyisi #',
  'invoices.table_client': 'Ikhasimende',
  'invoices.table_issue_date': 'Usuku Lokukhishwa',
  'invoices.table_due_date': 'Usuku Lokugcina Lokukhokha',
  'invoices.table_total': 'Inani Lilonke',
  'invoices.table_status': 'Isimo',
  'invoices.download_pdf': 'Landa i-PDF',
  'invoices.mark_as_paid': 'Maka Njengekhokhiwe',
  'invoices.no_records': 'Awekho ama-invoyisi akhiqiziwe okwamanje. Yakha i-invoyisi ukuze ulandelele izinkokhelo.',

  // Expenses View
  'expenses.title': '💳 Izindleko Zebhizinisi & Neleja',
  'expenses.subtitle': 'Ukulandelela izindleko nokwehlisa intela ngokusemthethweni',
  'expenses.log_expense': 'Faka Izindleko',
  'expenses.import_csv': 'Faka i-CSV',
  'expenses.total_outflow': 'Izindleko Eziphelele',
  'expenses.tax_deductible': 'Ehliswayo Enteleni',
  'expenses.search_placeholder': 'Sesha ngomdayisi noma incazelo...',
  'expenses.filter_all': 'Zonke Izigaba',
  'expenses.table_category': 'Isigaba',
  'expenses.table_description': 'Incazelo / Umdayisi',
  'expenses.table_date': 'Usuku',
  'expenses.table_claimable': 'Iyabuyiselwa Enteleni',
  'expenses.table_amount': 'Inani',
  'expenses.table_actions': 'Izenzo',
  'expenses.claimable_yes': 'Yebo (Yehlisa Intela)',
  'expenses.claimable_no': 'Cha (Okomuntu)',
  'expenses.no_records': 'Azikho izindleko ezirekhodiwe okwamanje. Faka izindleko zebhizinisi ukubala inzuzo yangempela.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Umgomo Wosuku & Nohlelo Lwemali',
  'focus.subtitle': 'Imisebenzi ebalulekile eletha imali nokusimama kwebhizinisi',
  'focus.add_task': 'Faka Umsebenzi Wemali',
  'focus.active_tasks': 'Imisebenzi Ebalulekile Eqhubekayo',
  'focus.completed_tasks': 'Imisebenzi Eqediwe',
  'focus.high_leverage': 'Okuseqhulwini',
  'focus.mark_done': 'Qeda',
  'focus.delete_task': 'Susa',
  'focus.no_tasks': 'Konke kufeziwe! Faka umsebenzi omusha ukuze ugcine umfutho.',

  // Automated Operational Engine
  'ai.title': '⚡ Injini Yokusebenza Ezenzekelayo',
  'ai.subtitle': 'Izibalo ezibethelwe eziphephile kwi-browser nokuqondisa ukusebenza (Ngaphandle kokugcina idatha eyimfihlo)',
  'ai.ask_placeholder': 'Buza mayelana nokuhamba kwemali, ukwandisa inzuzo noma izindlela zokubeka amanani...',
  'ai.send': 'Hlaziya',
  'ai.thinking': 'Injini yokusebenza ihlaziya izibalo zakho zemali...',
  'ai.prompt_margin': 'Ngingayenyusa kanjani inzuzo yami ibe ku-60%?',
  'ai.prompt_tax': 'Iziphi izindleko okufanele ngizifake ukuze nginciphise intela?',
  'ai.prompt_pricing': 'Kufanele ngiwahlele kanjani amanani amaphakheji ami ezinsizakalo?',
  'ai.clear_chat': 'Sula Umlando',

  // Business & Tax HQ
  'hq.title': '🏢 Indlunkulu Yebhizinisi & Nentela',
  'hq.subtitle': 'Iphrofayili, imali, imithetho yentela (VAT), izilungiselelo zezwe nemibiko yama-akhawunti',
  'hq.tab_profile': 'Iphrofayili & Nobunikazi',
  'hq.tab_currency_tax': 'Imali & Nemithetho Yentela',
  'hq.tab_accountant_view': 'Ukubuka Kuka-Accountant & CPA Audit',
  'hq.tab_exports': 'Khipha & Londoloza Idatha',
  'hq.tab_security': 'Ukuphepha & Ukuvikelwa',
  'hq.jurisdiction_preset_title': 'Izilungiselelo Zezwe Lendawo Yakho',
  'hq.jurisdiction_preset_desc': 'Khetha izwe lakini ukuze ulungise ngokuzenzakalelayo imali yendawo, intela ye-VAT nesikhungo sentela (SARS njll).',
  'hq.accountant_view_title': 'Ukubuka Kuka-Accountant & CPA Audit',
  'hq.accountant_view_desc': 'Isifinyezo esiphelele sezibalo zangaphambili esilungele i-accountant yangaphandle noma ukubuka kwebhange.',
  'hq.export_pdf_audit': 'Umbiko Wokucwaningwa Kwamabhuku Oyi-PDF Eprintwayo',
  'hq.export_csv_audit': 'Khipha Ifayela Lokucwaninga le-CSV',
  'hq.currency_symbol': 'Uphawu Lwemali',
  'hq.currency_code': 'Ikhodi Yemali',
  'hq.vat_rate': 'Inani le-VAT / Lentela (%)',
  'hq.tax_authority': 'Igama Lesikhungo Sentela',
  'hq.save_settings': 'Gcina Izilungiselelo Zebhizinisi',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Imali Engenayo Yonke',
  'metric.total_expenses': 'Izindleko Eziphelele',
  'metric.net_profit': 'Inzuzo Yokusebenza Yangempela',
  'metric.profit_margin': 'Izinga Lenzuzo Yokusebenza',
  'metric.active_bookings': 'Ukubhukha Okusebenzayo',
  'metric.paid_invoices': 'Ama-invoyisi Akhokhiwe',
  'metric.unpaid_invoices': 'Ama-invoyisi Asalindile',
  'metric.tax_buffer': 'Isiphetho Sentela Esilinganiselwe',
  'metric.currency': 'Imali Yokusebenza',
  'metric.tax_rate': 'Isilinganiso se-VAT / Sentela',

  // Actions & Common Buttons
  'btn.save': 'Gcina Izinguquko',
  'btn.cancel': 'Khansela',
  'btn.download': 'Landa',
  'btn.export_pdf': 'Landa Umbiko njenge-PDF',
  'btn.export_csv': 'Khipha njenge-CSV',
  'btn.cpa_pack': 'Khipha Iphakethe lika-Accountant',
  'btn.new_booking': 'Bhalisa Ukubhukha',
  'btn.new_expense': 'Bhalisa Izindleko',
  'btn.add_task': 'Faka Umsebenzi',
  'btn.sync_calendar': 'Vumelanisa Ikhalenda ye-Google',
  'btn.privacy_mode': 'Imodi Yobumfihlo',
  'btn.manage_subscription': 'Phatha Ukubhalisa',
  'btn.sign_in': 'Ngena / Ukufinyelela',
  'btn.sign_out': 'Phuma',
  'btn.delete': 'Susa',
  'btn.edit': 'Hlela',
  'btn.close': 'Vala',

  // Statuses
  'status.paid': 'Kukhokhiwe',
  'status.unpaid': 'Akukhokhiwe',
  'status.overdue': 'Kwephuze Isikhathi',
  'status.safe': 'Inzuzo Enempilo',
  'status.warning': 'Isexwayiso Senzuzo',
  'status.trial_active': 'Isivivinyo Samahhala Siyasebenza',
  'status.pro_active': 'Sovereign Pro',
};
